
// can only contain letters, numbers, hyphens and underscores
export const usernameReg = /^[A-Za-z0-9_-]+$/

// must contain at least one uppercase letter, one lowercase letter, one number and a special character included in [@$!%*#?&]
export const passwordReg = /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[@$!%*#?&]).+$/